export class DomainHelper {
  static isHttps(domain: string): boolean {
    return domain.startsWith('https://');
  }

  static isHttp(domain: string): boolean {
    return domain.startsWith('http://');
  }

  static isHttpOrHttps(domain: string): boolean {
    return this.isHttp(domain) || this.isHttps(domain);
  }

  static getProtocol(domain: string): 'http' | 'https' | null {
    if (this.isHttps(domain)) return 'https';
    if (this.isHttp(domain)) return 'http';
    return null;
  }

}
